import { GeoDsDocument } from '../../models/geods-document.model';

export interface Labels {
  Title?: string;
  ListView?: string;
  DataGrid?: string;
  AddDocument?: string;
  Preview?: string;
  Download?: string;
  Delete?: string;
  Details?: string;
  NoData?: string;
  Previous?: string;
  Next?: string;
  UploadDocument?: string;
  UploadImage?: string;
  PlaceFileHere?: string;
  ConfirmDelete?: string;
  DeleteMsg?: string;
  Cancel?: string;
  Designation?: string;
  FileName?: string;
  InsertedBy?: string;
  Kind?: string;
  InsertDate?: string;
  Loading?: string;
  Size?: string;
  Search?: string;
  Actions?: string;
  InvalidMaxFileSizeMessage?: string;
  DeleteImage?: string;
  CaptureImage?: string;
  Camera?: string;
  Upload?: string;
  Archive?: string;
  ConfirmArchive?: string;
  ArchiveMsg?: string;
  Filter?: string;
}

export interface userInfo {
  FirstName: string;
  LastName: string;
  EMail: string;
}

export enum Actions {
  get = 'get',
  add = 'add',
  edit = 'edit',
  delete = 'delete',
  download = 'download',
  preview = 'preview',
}

export enum Status {
  success = 'success',
  fail = 'fail',
}

export interface IActionCompleted {
  action: Actions;
  status: Status;
}

export interface IActionButtonsMenuOutput {
  target: any;
  selectedDocument: GeoDsDocumentViewModel;
}

export const defaultLabels: Labels = {
  Title: 'Dokumente',
  ListView: 'Liste',
  DataGrid: 'Raster',
  AddDocument: 'Dokument hinzufügen',
  Preview: 'Vorschau',
  Download: 'Herunterladen',
  Delete: 'Löschen',
  Details: 'Einzelheiten',
  NoData: 'Keine Daten..',
  Previous: 'Vorherige',
  Next: 'Weiter',
  UploadDocument: 'Dokument hochladen',
  UploadImage: 'Bild hochladen',
  PlaceFileHere: 'oder Datei hier ablegen',
  ConfirmDelete: 'Bestätigen Löschen',
  DeleteMsg: 'Sind Sie sicher, dass Sie dieses Dokument löschen möchten ?',
  Cancel: 'Abbrechen',
  Designation: 'Benennung ',
  FileName: 'Dateiname',
  InsertedBy: 'Ersteller',
  Kind: 'Typ',
  InsertDate: 'Einfügedatum',
  Loading: 'Laden',
  Size: 'Größe',
  Search: 'Suche',
  Actions: 'Aktionen',
  InvalidMaxFileSizeMessage: 'Die Datei ist zu groß',
  DeleteImage: 'Bild löschen',
  CaptureImage: 'Bild einfangen',
  Camera: 'Kamera',
  Upload: 'Hochladen',
  Archive: 'Archivierer',
  ConfirmArchive: 'Archiv bestätigen',
  ArchiveMsg: 'Möchten Sie dieses Dokument wirklich archivieren?',
  Filter: 'Filter',
};

interface IExtension {
  images: string[];
  videos: string[];
  files: string[];
}

export interface IDeleteConditions {
  allowDelete: boolean;
  deactiveDeleteAfterSpecificTime: boolean;
  allowDeleteOnlyToCreator: boolean;
  TimeInHoursToDeactivateDelete: number;
  userId: string;
}

export enum View {
  Camera = 'camera',
  FileUploader = 'fileUploader',
  CameraAndFileUploader = 'cameraAndFileUploader',
}

export enum DxScrollingMode {
  Standard = 'Standard',
  Virtual = 'Virtual',
  Infinite = 'Infinite',
}

export enum ColumnChooserMode {
  DragAndDrop = 'dragAndDrop',
  Select = 'select',
}

export enum ColumnChooserSortOrder {
  Ascendant = 'asc',
  descendant = 'desc',
}

export enum FilterPanelMode {
  Toolbar = 'toolbar',
  GridBottom = 'gridBottom',
}

export interface DocumentListGridOptions {
  enableLoadPanel?: boolean;
  isGroupPanelVisible?: boolean;
  isFilterRowVisible?: boolean;
  isFilterPanelVisible?: boolean;
  filterPanelMode?: FilterPanelMode;
  enableExport?: boolean;
  allowExportSelectedData?: boolean;
  isHeaderFilterVisible?: boolean;
  scrollingMode?: DxScrollingMode;
  enablePaging?: boolean;
  enableColumnChooser?: boolean;
  columnChooserMode?: ColumnChooserMode;
  columnChooserSortOrder?: ColumnChooserSortOrder;
}

export const defaultGridOptions: DocumentListGridOptions = {
  enableLoadPanel: true,
  isGroupPanelVisible: true,
  isFilterRowVisible: true,
  isFilterPanelVisible: true,
  filterPanelMode: FilterPanelMode.GridBottom,
  enableExport: false,
  allowExportSelectedData: false,
  isHeaderFilterVisible: true,
  scrollingMode: DxScrollingMode.Virtual,
  enablePaging: false,
  enableColumnChooser: true,
  columnChooserMode: ColumnChooserMode.Select,
  columnChooserSortOrder: ColumnChooserSortOrder.Ascendant,
};

export interface IApiResult {
  Id: string;
  ObjectType: string;
}

export const Extenstions: IExtension = {
  images: ['jpeg', 'jpg', 'png', 'svg', 'bmp', 'tif', 'tiff', 'eps', 'raw', 'cr2', 'nef', 'orf', 'sr2', 'gif', 'jfif'],
  videos: ['mp4'],
  files: ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'txt'],
};

export class GeoDsDocumentViewModel extends GeoDsDocument {
  IdRefPersonInsertFullName: string;
  IdRefPersonInsertEmail: string;
  allowDownload: boolean;
  allowDelete: boolean;
  allowPreview: boolean;
  allowDetails: boolean;
  selected?: boolean;
  icon?: string;
  IsArchived?: string;
  constructor(data: GeoDsDocumentViewModel) {
    super(data);
    Object.assign(this, data);
  }
}

export interface IContextMenuItems {
  text: string;
  icon: string;
  visible: boolean;
  class?: string;
  onClick: (event?: any) => void;
}
